import { Func } from "../_utils/fnTypes";
import { ICustomScrollStore } from "../_store/CustomScrollStoreModel";

export interface IThumbParams {
    thumbOffset: number;
    thumbMeasure: number;
    railMeasure: number;
}

export const defaultThumbParams: IThumbParams = {
    thumbOffset: 0,
    thumbMeasure: 0,
    railMeasure: 0,
};

export type TThumbApi = [
    HTMLDivElement,
    Func<IThumbParams>,
    ICustomScrollStore
];
